import { render, staticRenderFns } from "./Nutrition.vue?vue&type=template&id=2b3634c0&scoped=true&"
import script from "./Nutrition.vue?vue&type=script&lang=js&"
export * from "./Nutrition.vue?vue&type=script&lang=js&"
import style0 from "./Nutrition.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Nutrition.vue?vue&type=style&index=1&id=2b3634c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3634c0",
  null
  
)

export default component.exports